module.exports = __webpack_public_path__ + "img/ws.69b52e9a.svg";